const listeners = new Set()

export function setPageLoading(next) {
    listeners.forEach((listener) => listener(next))
}

export function onPageLoading(listener) {
    listeners.add(listener)
    return () => listeners.delete(listener)
}